module.exports = __webpack_public_path__ + "static/jewelry-logo-14cc8fa82276d143c0f33a01d98903a7.svg";